export const COORDINATOR_COLUMNS = {
  name: {
    key: 'name',
    label: 'Name',
    isSortable: false,
  },
  phone: {
    key: 'phone',
    label: 'Phone Number',
    isSortable: false,
  },
  currentShift: {
    key: 'currentShift',
    label: 'Current Shift Till',
    isSortable: false,
  },
  nextShift: {
    key: 'nextShift',
    label: 'Next On Call/Duty Shift',
    isSortable: false,
  },
  action: {
    key: 'action',
    label: '',
    isSortable: false,
  },
};

export const getCoordinatorColumns = () => [
  COORDINATOR_COLUMNS.name,
  COORDINATOR_COLUMNS.phone,
  COORDINATOR_COLUMNS.currentShift,
  COORDINATOR_COLUMNS.nextShift,
  COORDINATOR_COLUMNS.action,
];
